module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f2"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rdedi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062376886_Dedication#dedi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "repi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062376886_Epigraph#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062376886_Chapter_1#ch1"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062376886_Chapter_2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062376886_Chapter_3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062376886_Chapter_4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062376886_Chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062376886_Chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062376886_Chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpra"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062376886_Praise#pra",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ralso"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062376886_Also_by#also",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Tobias Wolff")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "back"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062376886_Back_Ad#rback",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Back Ad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rcopy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062376886_Copyright#copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ratp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#atp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b5c295b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062376886_Contents.vue
// module id = 69
// module chunks = 0